import React, { useState } from "react";
import { useSelector } from "react-redux";
import CardGeneric from "../../components/common/CardGeneric";
import TokenFamily from "./TokenFamily";
import { generarTokenFamiliar } from "../../redux/api/affiliate";
import Modal from "@material-ui/core/Modal";
import ModalTokenGenerado from "../../components/common/ModalTokenGenerado";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

const Token = () => {

    const [openModal, setOpenModal] = useState(false);
    const [token, setToken] = useState("");
    const [fechaVencimiento, setFechaVencimiento] = useState("");
    const { family, user, authToken } = useSelector(state => state.auth) 


    const handleGenerarTokenFamiliar = async (afiliado) => {
        const data = {
            afiliado_id: afiliado.afiliado_id,
            authToken 
        };

        const response = await generarTokenFamiliar(data);

        if (response.error) {
            console.error(response.error);
            return;
        }

        setToken(response.token);
        setFechaVencimiento(response.fechaVencimiento);
        setOpenModal(true);
    }

    return (
    <>
        <CardGeneric
            title="Token para familiar"
            icon={<VpnKeyIcon />}
        >
            <TokenFamily
                handleGenerarToken={handleGenerarTokenFamiliar}
                />
        </CardGeneric>

        <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    outline: "none"
                }}
            >
                <ModalTokenGenerado
                    token={token}
                        authToken={authToken} 
                    fechaVencimiento={fechaVencimiento}
                    handleClose={() => setOpenModal(false)}
                />
            </div>
        </Modal>
    </>
);
};

export default Token;

